import React from "react";
import "./Website.css";
import { useNavigate } from 'react-router-dom';


function Website(){

  const navigate = useNavigate();


    return(
        <div className="contents">
  <div className="container">
  {/* <!-- Row 1: Three Cards --> */}
  <div className="row justify-content-center g-4">
    <div className="col-md-4">
      <div className="cardid card border border-dark">

                      <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
              <img src="webs.png" alt="Logo"/>
           Website Designing</h5>
          <p className="card-text">We design websites that are creative, mobile responsive, lag-free, eye-catching, and SEO friendly. We also provide custom mobile web design services in Coimbatore at an affordable cost. We design most of the websites through an open-source content management system (CMS). If you need a web designer, then hire us to work on your website to make it beautiful and profitable.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className=" cardid card  border border-dark">

                      <div className="corner-circle "></div>

        <div className="card-body">
         <h5 className="card-title">
        <img src="webdevop.png" alt="Logo"/>
           Website Development</h5>
          <p className="card-text">We work to create highly optimized mobile-responsive web applications across diverse industries, ensuring optimal performance. Our expertise lies in developing customized websites that include various features to integrate with all business intelligence. We deliver high-quality web development solutions with precision and proficiency, which aligns with your business needs.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="static.png" alt="Logo"/>
           Static & Dynamic Website</h5>
          <p className="card-text">We create professional static websites for small businesses and start-ups with high levels of quality and reliability. We make attractive, mobile-friendly websites. These web pages will amaze your website visitors and generate more leads and revenue for your business. We do not only design static websites but also design dynamic websites using CMS and other leadingtechnologies.</p>
        </div>
      </div>
    </div>
  </div>

  <div className="row justify-content-center g-4 mt-3">
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

        <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="webs.png" alt="Logo"/>
            Responsive Website</h5>
          <p className="card-text">We are the no.1  web design firm in Coimbatore.<br/>
           Our specialty is designing mobile-responsive, <br/>
           visually appealing websites. To keep people’s<br/> attention,
            we make sure to offer engaging and educational content. <br/>
            Through our expertise, we make sure that our professional website provides relevant<br/>
             messages to engaging audiences effectively and efficiently.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle"></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="ecomerce.png" alt="Logo"/>
          Ecommerce Development</h5>
          <p className="card-text">Utilizing our expertise in shopping cart development, well-structured e-commerce front stores, and implementing our unique web design services you can maximize the leads and grow your business. With over 50+ pre-built website templates and a <br/>
          rich portfolio of 80+ features, our platform strengthens <br/>you to effortlessly launch and <br/>
          manage your online e-commerce store.</p>
        </div>
      </div>
    </div>

      <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="port.png" alt="Logo"/>
          Portfolio Website</h5>
          <p className="card-text">We design professional portfolio websites that showcase your work with clarity, creativity, and impact. Whether you're an artist, freelancer, or professional, we craft visually stunning, mobile-responsive sites that highlight your skills and achievements. From sleek static designs to dynamic CMS-powered layouts, we ensure your portfolio stands out, engages visitors, and opens doors to new opportunities.</p>
        </div>
      </div>
    </div>

  </div>
</div>


<button type="button" className="exitbutton btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Move to Previous
</button>


<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Exit page</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      Are You Really want to Exit this page..
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary"onClick={() => navigate('/')}>Yes</button>
      </div>
    </div>
  </div>
</div>


        </div>
    )

}
export default Website;